import React from "react";
import { useSelector } from "react-redux";
import { AppState } from "../config/redux/reducers";


import {
  createGetAllPlannedRoutesPayload,
  createUpdateOrderStatusPayload,
  getAllAreasAndSlots,
  getDiscardRoutePayload,
  transformRouteConsignments,
  getAddressInfo,
  getRouteStatusField,
  getConsignmentStatusField,
  checkTerminalStatus,
} from "../mocks/carrefourHomeDelivery/response.transforms";
import { getConsignmentData, createDraftRoutePayload, calculateTransitTime, createRouteCreationPayload,  getTotalCrates, createGetAllDropdownsPayload} from "../mocks/SharedTransform/response.transforms";
import {
  createDraftRoute,
  createAndEditRoute,
  fetchAllDrivers,
  fetchAllHelpers,
  fetchAllVehicles,
  fetchAllPlannedRoutes,
  updateConsignmentStatus,
  discardRouteChanges,
  resetPlanningError,
  updateAllConsignmentsState,
  loadAllSlots,
  clearCurrentSlot,
  fetchRouteConsignments,
  clearUpdatedRoute,
} from "./redux/carrefourDeliverySlice";
import { userLogout } from "../Login/redux/loginSlice";

import CarrefourDeliveryOrderDetails from "./CarrefourDeliveryOrderDetails";
import CreateRouteCommon from '../SharedComponent/components/createRoute';
import AppConstants from '../constants';
import UACConstants from '../constants/UACConstants';


interface CreateRouteProps {
  location?: any;
  match?: any;
  editMode?: boolean;
  viewMode?: boolean;
}

const CreateRoute = (props: CreateRouteProps) => {
  const { editMode, viewMode, match, location } = props;
  const {
    loading,
    draftRoute,
    areawiseConsignments,
    slotwiseConsignments,
    allConsignments,
    routeConsignments,
    slotwisePlannedRoutes,
    driversList,
    helpersList,
    vehiclesList,
    vehiclesData,
    routeCreateSuccess,
    updatedRoute,
    routeDiscardSuccess,
    currentSlot,
    slotsList,
    consignmentStatusList,
    error,
    errorCode,
  } = useSelector((state: AppState) => state.carrefourDelivery);


  return (
    <CreateRouteCommon
      OrderDetailsComponent={CarrefourDeliveryOrderDetails}
      deliveryState={{
        loading,
        draftRoute,
        areawiseConsignments,
        slotwiseConsignments,
        allConsignments,
        routeConsignments,
        slotwisePlannedRoutes,
        driversList,
        helpersList,
        vehiclesList,
        vehiclesData,
        routeCreateSuccess,
        updatedRoute,
        routeDiscardSuccess,
        currentSlot,
        slotsList,
        consignmentStatusList,
        error,
        errorCode,
      }}
      actions={{
        createDraftRoute,
        createAndEditRoute,
        fetchAllDrivers,
        fetchAllHelpers,
        fetchAllVehicles,
        fetchAllPlannedRoutes,
        updateConsignmentStatus,
        discardRouteChanges,
        resetPlanningError,
        updateAllConsignmentsState,
        loadAllSlots,
        clearCurrentSlot,
        fetchRouteConsignments,
        clearUpdatedRoute,
        userLogout,
      }}
      transforms={{
        calculateTransitTime,
        createDraftRoutePayload,
        createGetAllDropdownsPayload,
        createGetAllPlannedRoutesPayload,
        createRouteCreationPayload,
        createUpdateOrderStatusPayload,
        getAllAreasAndSlots,
        getConsignmentData,
        getDiscardRoutePayload,
        getTotalCrates,
        transformRouteConsignments,
        getAddressInfo,
        getRouteStatusField,
        getConsignmentStatusField,
        checkTerminalStatus,
      }}
      editMode={editMode}
      viewMode={viewMode}
      match={match}
      location={location}
      editRoutePath={AppConstants.ROUTES.CARREFOUR_DELIVERY_EDIT_ROUTE}
      componentName='chd'
      uacKey={UACConstants.HD_ROUTES}
    />
  );
};

export default CreateRoute;
